export const RESET = 'EXSBORDER_UPDATE_RESET'
export const SET_ERROR = 'EXSBORDER_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXSBORDER_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXSBORDER_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXSBORDER_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXSBORDER_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXSBORDER_UPDATE_UPDATE_RETRIEVED'
